import formatDate from 'library/functions/formatDate'

// 操作日志列表
export const PERSON_IN_CHARGE_LIST = [
    {
        label: '操作人',
        prop: 'createPerson',
    },
    {
        label: '操作时间',
        prop: 'createTime',
        formatter: (value) => {
            return value ? formatDate(value, 'yyyy-MM-dd HH:mm:ss') : '--'
        },
    },
    {
        label: '操作',
        prop: 'type',
    },
    {
        label: '操作月份',
        prop: 'memo',
    },
    {
        label: '操作结果',
        prop: 'isSuccess',
        formatter: (value) => {
            return value === 1 ? '成功' : '失败'
        },
    },
]